import React, { useState, useEffect, useContext } from 'react';
import {Grid, GridColumn as Column, GridCellProps, GridToolbar, getSelectedState, GridSelectionChangeEvent, GridHeaderCellProps} from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { getAdSubelements } from '../services/apiService';
import { subElement } from '../services/interfaces';
import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { getter } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import parse from 'html-react-parser';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { getmmJobFiles } from '../services/apiService';
import { mmJob } from '../services/interfaces';


export function MMFileList (selectedJob:mmJob){
    const [subs, setSubs] = useState<Array<subElement>>([]);
    const pageContext=useContext(PageContext);
    const [sendEmailVisible, setSendEmailVisible]=useState(false);
    const [showContactNote, setShowContactNote] = useState(false);
    
    
    const getSubs=()=>{
        const jobName = selectedJob.mmJobName;
        const type = pageContext?.selectedAd.elementType;
        const elpath = pageContext?.selectedAd.path;
        if (jobName){
            getmmJobFiles(jobName).then(data=>{
                //console.log(data);
                setSubs(data);
            });
        }
    }

    const linkableCell=(props:GridCellProps)=>{
        //console.log(props.dataItem);
        const label = props.dataItem["relativePath"]!=""? props.dataItem["relative_Path"]+props.dataItem["sub_Element"]: props.dataItem["sub_Element"]
        return(
            <td>
                <a target="_blank" href={props.dataItem["path"]} download>{label}</a>
            </td>
        )
    }

    useEffect(() => {
        getSubs();
    }, []);
    return(
        <>        
        <Grid
            data={subs}
            dataItemKey='mmOrigFilename'
            scrollable='scrollable'
        >            
            <Column
                field="mmOrigFilename"
                title="File Name"
            />
        </Grid>
        </>
    )
}